import { Fragment } from 'react';
import { Link } from 'react-router-dom';

import Icon from 'components/Icon';
import Image from 'components/Image';
import Picture from 'components/Picture';

const WebsiteBuilder = () => (
  <Fragment>
    <section className="section section_website-builder_1">
      <div className="wrapper">
        <div className="row">
          <div className="col col-6 col-tablet-12">
            <h1 className="title title_size_xl title_white _mb-20 _mt-127 _mt-tablet-0 _mt-quad-153">
              <span className="title__break">Build your</span> own website
            </h1>
            <p className="text text_size_xl text_white section__text">
              <span className="text__break">Simple drag & drop editing</span>{' '}
              with guided content.
            </p>
          </div>
          <div className="col col-6">
            <div className="section__image-wrap">
              <Picture className="section__image" src="img-09.png" />
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="section section_website-builder_2">
      <div className="wrapper">
        <div className="row">
          <div className="col col-4 col-tablet-12">
            <div className="_mt-110 _mt-tablet-0 _mb-tablet-40">
              <h2 className="title title_size_l _mb-16">
                <span className="title__break">Drag & Drop</span> Site Editor
              </h2>
              <p className="text">
                Creating a website has never been easier! Just add and move
                photos, videos, maps and forms, and click&#8209;to&#8209;edit
                text and colors. Whether you're a beginner or professional,
                Siteplus was made for everyone.
              </p>
            </div>
          </div>
          <div className="col col-7 col-tablet-12 offset-1 offset-tablet-0">
            <div className="section__image-wrap">
              <Image src="img-01.png" />
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="section section_website-builder_3">
      <div className="wrapper">
        <div className="row row-reverse-tablet section__row">
          <div className="col col-4 col-laptop-5 col-tablet-12">
            <div className="section__images-group-wrap">
              <Image src="img-38.png" className="section__image-group_first" />
              <Image src="img-43.jpg" className="section__image-group_second" />
              <video
                className="video section__video"
                autoPlay
                loop
                muted
                playsInline
                poster={require('../public/images/img-166.png')}
              >
                <source
                  src={require('../public/video/phone-bg.webm')}
                  type="video/webm"
                />
                <source
                  src={require('../public/video/phone-bg.mp4')}
                  type="video/mp4"
                />
              </video>
            </div>
          </div>
          <div className="col col-5 offset-1 col-tablet-12 offset-tablet-0">
            <div className="_mt-229 _mb-tablet-60 _mt-tablet-0">
              <h2 className="title title_size_l _mb-16">
                <span className="title__break">Look great</span> on any device
              </h2>
              <p className="text">
                Your website and photos will automatically resize to any device,
                meaning it will always look amazing and function smoothly,
                whether it's being viewed on a desktop, smartphone or tablet.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="section section_website-builder_4">
      <div className="wrapper section__wrapper">
        <div className="row">
          <div className="col col-6 col-tablet-12">
            <div className="_mt-99 _mt-tablet-0">
              <h2 className="title title_size_l _mb-16">
                Choose from 150+ website templates
              </h2>
              <p className="text _mb-24 col-10 col-tablet-12">
                No design skills required. Our fully customizable templates are
                designed by top designers and cover every industry. From small
                business websites and engaging blogs to Online Shops &ndash; we
                do it all!
              </p>
              <div className="section__link-wrap _mb-tablet-30">
                <Link to="/templates" className="link">
                  View all templates
                  <Icon className="link__icon" icon="arrow-text-2" />
                </Link>
              </div>
            </div>
          </div>
          <div className="col col-6 col-tablet-12">
            <div className="section__images-group-wrap">
              <div className="section__image-wrap section__image-wrap_back">
                <Picture
                  className="section__image section__image_back"
                  src="img-160.png"
                />
              </div>
              <div className="section__image-wrap section__image-wrap_middle">
                <Picture
                  className="section__image section__image_middle"
                  src="img-161.png"
                />
              </div>
              <div className="section__image-wrap section__image-wrap_front">
                <Picture
                  className="section__image section__image_front"
                  src="img-162.png"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="section section_website-builder_5">
      <div className="wrapper">
        <div className="row row-reverse-tablet">
          <div className="col col-6 col-tablet-12 section__col">
            <div className="section__image-wrap">
              <Image className="section__image" src="img-05.png" />
              <span className="section__image-bubble section__image-bubble_1" />
              <span className="section__image-bubble section__image-bubble_2" />
              <span className="section__image-bubble section__image-bubble_3" />
              <span className="section__image-bubble section__image-bubble_4" />
              <span className="section__image-bubble section__image-bubble_5" />
              <span className="section__image-bubble section__image-bubble_6" />
              <span className="section__image-bubble section__image-bubble_7" />
              <span className="section__image-bubble section__image-bubble_8" />
              <span className="section__image-bubble section__image-bubble_9" />
              <span className="section__image-bubble section__image-bubble_10" />
            </div>
          </div>
          <div className="col col-5 offset-1 col-tablet-12 offset-tablet-0 _mb-tablet-80">
            <div className="_mt-61 _mt-tablet-0">
              <h2 className="title title_size_l _mb-16">
                <span className="title__break">Be found in</span> Google with
                SEO
              </h2>
              <p className="text">
                To ensure your website is right at the top of Google's search
                results, Siteplus website builder gives you guided SEO control
                and applies many settings automatically and seamlessly in the
                background.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="section section_website-builder_6">
      <div className="wrapper">
        <div className="row section__row">
          <div className="col col-5 col-tablet-12">
            <div className="_mb-tablet-40">
              <h2 className="title title_size_l _mb-16">
                One-click publish to your domain
              </h2>
              <p className="text">
                Easily connect your own domain to your new website or register a
                new one, then click publish. It's that easy! Edit and add more
                pages as required, at any time.
              </p>
            </div>
          </div>
          <div className="col col-7 col-tablet-12">
            <div className="section__image-wrap">
              <Image src="img-06.png" />
              <video
                className="video section__video"
                autoPlay
                loop
                muted
                playsInline
                poster={require('../public/images/img-167.png')}
              >
                <source
                  src={require('../public/video/laptop-screen.mp4')}
                  type="video/mp4"
                />
              </video>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="section section_website-builder_7">
      <div className="wrapper">
        <h2 className="title title_size_l title_white section__main-title _mb-57">
          Engage with customers
        </h2>
        <div className="row">
          <div className="col col-4 col-tablet-portrait-12">
            <div className="_mb-tablet-40">
              <div className="section__icon-wrap _mb-30">
                <Icon
                  className="section__icon section__icon_first"
                  icon="icon-5"
                />
              </div>
              <h4 className="title title_size_s title_white section__title _mb-17">
                Click to Call
              </h4>
              <p className="text text_white section__text">
                Add a click&#8209;to&#8209;call button so customers can easily
                reach you.
              </p>
            </div>
          </div>
          <div className="col col-4 col-tablet-portrait-12">
            <div className="_mb-tablet-40">
              <div className="section__icon-wrap _mb-30">
                <Icon
                  className="section__icon section__icon_second"
                  icon="icon-6"
                />
              </div>
              <h4 className="title title_size_s title_white section__title _mb-17">
                Show your Location
              </h4>
              <p className="text text_white section__text">
                Show your pin&#8209;point location and directions to your
                premises with Google Maps.
              </p>
            </div>
          </div>
          <div className="col col-4 col-tablet-portrait-12">
            <div className="_mb-tablet-40">
              <div className="section__icon-wrap _mb-30">
                <Icon
                  className="section__icon section__icon_third"
                  icon="icon-7"
                />
              </div>
              <h4 className="title title_size_s title_white section__title _mb-17">
                Contact Forms
              </h4>
              <p className="text text_white section__text">
                Create online contact forms with multiple fields that submit to
                your email.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="section section_website-builder_8">
      <div className="wrapper section__wrapper">
        <div className="section__header-wrap _mb-58">
          <h3 className="title title_size_l _mb-21 section__main-title">
            All the features you need
          </h3>
          <p className="text text_size_xl section__main-text">
            Do it all with powerful, simplified features you'll love.
          </p>
        </div>
        <div className="row _mb-27">
          <div className="col col-4 col-tablet-portrait-12">
            <div className="section__box _mb-40">
              <div className="section__icon-wrap _mb-14">
                <Icon icon="icon-8" />
              </div>
              <h5 className="title title_size_xs_old section__title _mb-8">
                Fully Customizable
              </h5>
              <p className="text section__text">
                Customize your website from top to bottom &ndash; everything
                from your logo, styles, menus, colors, fonts and more.
              </p>
            </div>
          </div>
          <div className="col col-4 col-tablet-portrait-12">
            <div className="section__box _mb-40">
              <div className="section__icon-wrap _mb-14">
                <Icon icon="icon-9" />
              </div>
              <h5 className="title title_size_xs_old section__title _mb-8">
                Mobile Editing
              </h5>
              <p className="text section__text">
                Update your website anywhere, from any mobile device. Edit all
                your content and photos quickly and easily.
              </p>
            </div>
          </div>
          <div className="col col-4 col-tablet-portrait-12">
            <div className="section__box _mb-40">
              <div className="section__icon-wrap _mb-14">
                <Icon icon="icon-10" />
              </div>
              <h5 className="title title_size_xs_old section__title _mb-8">
                Blogging
              </h5>
              <p className="text section__text">
                Create beautiful blog posts with our editing tools. Style your
                layouts and import images or videos to help express your story.
              </p>
            </div>
          </div>
          <div className="col col-4 col-tablet-portrait-12">
            <div className="section__box _mb-40">
              <div className="section__icon-wrap _mb-14">
                <Icon icon="icon-11" />
              </div>
              <h2 className="title title_size_xs_old section__title _mb-8">
                Premium Photos
              </h2>
              <p className="text section__text">
                Give your website impact with millions of professional
                high&#8209;resolution stock photos to choose from.
              </p>
            </div>
          </div>
          <div className="col col-4 col-tablet-portrait-12">
            <div className="section__box _mb-40">
              <div className="section__icon-wrap _mb-14">
                <Icon icon="icon-12" />
              </div>
              <h5 className="title title_size_xs_old section__title _mb-8">
                Unlimited Pages
              </h5>
              <p className="text section__text">
                Build your website to your liking and enjoy unlimited pages,
                photos, videos and more.
              </p>
            </div>
          </div>
          <div className="col col-4 col-tablet-portrait-12">
            <div className="section__box _mb-40">
              <div className="section__icon-wrap _mb-14">
                <Icon icon="icon-13" />
              </div>
              <h5 className="title title_size_xs_old section__title _mb-8">
                Flexible Page Layouts
              </h5>
              <p className="text section__text">
                Modify each page layout or use our smart pre&#8209;designed
                content blocks for a simplified design process.
              </p>
            </div>
          </div>
          <div className="col col-4 col-tablet-portrait-12">
            <div className="section__box _mb-40">
              <div className="section__icon-wrap _mb-14">
                <Icon icon="icon-14" />
              </div>
              <h5 className="title title_size_xs_old section__title _mb-8">
                Photo Galleries
              </h5>
              <p className="text section__text">
                Impress your visitors with a collection of stunning photo
                gallery layouts.
              </p>
            </div>
          </div>
          <div className="col col-4 col-tablet-portrait-12">
            <div className="section__box _mb-40">
              <div className="section__icon-wrap _mb-14">
                <Icon icon="icon-15" />
              </div>
              <h5 className="title title_size_xs_old section__title _mb-8">
                Instagram Portfolio
              </h5>
              <p className="text section__text">
                Automatically showcase your Instagram photos in your website
                gallery seamlessly as you post to Instagram.
              </p>
            </div>
          </div>
          <div className="col col-4 col-tablet-portrait-12">
            <div className="section__box _mb-40 section__box_center">
              <Link to="/features" className="link section__link">
                Show me more
                <Icon className="link__icon" icon="arrow-text-2" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  </Fragment>
);

export default WebsiteBuilder;
